export default function addTargetBlank(text = "") {
  return text && typeof text === "string"
    ? text.replace(/href=/g, 'target="_blank no-referer" href=')
    : text;
}
